import BaseOverlay from '../_base-overlay';


export default class SubscribeShownBIOverlay extends BaseOverlay {

  static displayName = 'SubscribeShownBIOverlay';

  componentDidMount() {
    // do not add BI param for not channel without video
    if (this.props.videoItem && this.subscribeButtonText) {
      this.props.biEvent('widget.subscription.displayed', { whereDisplayed: 'cover' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/bi/_subscribe-shown-bi-overlay.js